export default __webpack_public_path__ + "static/media/account.64253b1c.svg";